<template>
    <div class="sharePoup" v-show="isShow">
        <i class="el-icon-close" @click="close"></i>
        <p class="margin-10">微信扫码分享给好友</p>
        <p>邀请成为主播/管理员</p>
        <div class="share_item">
            <img :src="dataCode.inviteurl" alt="">
            <p>移动端</p>
        </div>
        <div class="share_item" v-if="dataCode.invitempcode">
            <img class="proImg" :src="dataCode.invitempcode" alt="">
            <p>小程序</p>
        </div>
    </div>
</template>

<script>
    import {urlToQRCode} from 'common/js/tools'
    export default {
        name: "sharePoup",
        data(){
            return{
                isShow:false,
                dataCode:{}
            }
        },
        methods:{
            open(data){
                this.dataCode=data
                this.dataCode.inviteurl=urlToQRCode(data.inviteurl);
                this.isShow=true
            },
            close(){
                this.isShow=false
            }
        }
    }
</script>

<style lang="scss">
    .sharePoup{
        width:226px;
        height:auto;
        background:rgba(255,255,255,1);
        box-shadow:0 0 6px 0 rgba(0,0,0,0.2);
        border-radius:4px;
        text-align: center;
        position: absolute;
        z-index: 999;
        right: 20px;
        padding: 10px 0;
        .el-icon-close{
            position: absolute;
            right: 10px;
            cursor: pointer;
        }
        p{
            line-height: 21px;
        }
        .margin-10{
            margin-top: 10px;
        }
        .share_item{
            margin-top: 10px;
            img{
                width: 100px;
                height: 100px;
                display: inline-block;
            }
            .proImg{
                border-radius: 50%;
            }
            p{
                font-size: 13px;
                color: #909399;
                line-height: 18px;
                margin-top: 5px;
            }
        }
    }
</style>
